import { useAuth } from '@/contexts/AuthContext';

/**
 * Returns the propertyId and unitId for the authenticated resident.
 * Residents have exactly one property role with a unitId.
 */
export function useResidentProperty(): {
  propertyId: string;
  unitId: string;
  unitName?: string;
} | null {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.propertyRoles.find((r) => r.role === 'resident');
  if (!role?.propertyId || !role.unitId) return null;
  return {
    propertyId: role.propertyId,
    unitId: role.unitId,
    ...(role.unitName != null && { unitName: role.unitName }),
  };
}
